import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(theming => ({
	// @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
	root: { marginBottom: theming.spacing(2) },
	title: {
		flexGrow: 1,
	},
}));
